import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import Global from "../../util/Global";
import moment from 'moment';
import {useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { LoaderComponent } from "../../util/Loader";
import NotFound from "../../components/NotFound";
import { Email as EmailIcon, TextFields as BodyIcon, CalendarToday as DateIcon } from '@mui/icons-material';
import { Avatar, TextField, Button,  Typography } from '@mui/material';
import { AlertContext } from "../../util/Alerter";



const MES_MESSAGE_URL = Global.backend + "/index.php/api/contact/show";
const SEND_MESSAGE_URL = Global.backend + "/index.php/api/contact/send";


const AdminDetailContact = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { passedMessage } = useParams()



  const [isLoading, setisLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [replySubject, setReplySubject] = useState('');
  const [replyBody, setReplyBody] = useState('');
  const { showAlert } = useContext(AlertContext)
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)



  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
    setpageTitle("emailBody")
    setalertTitle("")
    setnavLinks([{ path: "/dashboard/admin/contact", label: "inbox"}])
  }, [])



  useEffect(() => {
    try {
      setMessage(JSON.parse(decodeURIComponent(passedMessage)))
      setisLoading(false)
    } catch (err) {
      setisLoading(true)
    }


    axios.all([
      axios.post(MES_MESSAGE_URL, { id: id }),
    ])
      .then(axios.spread((messagesResponse, ViewResponse) => {
        setMessage(messagesResponse.data)
      })).catch(() => {
      }).finally(()=>{
        setisLoading(false)
      })
  }, []);



  function replyMessage() {
    setisLoading(true)

    axios.post(SEND_MESSAGE_URL, {
      email: message.email,
      subject: replySubject,
      body: replyBody
    })
      .then((response) => {
        if (response.data.message == "ok") {
          showAlert("success", t("request.successReplyingEmail"))
        } else {
          showAlert("error", t("request.errorReplyingEmail"))
        }
      }).catch(() => {
        showAlert("error", t("request.errorReplyingEmail"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }




  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading && (
        !message ? <NotFound /> :
          <div className="container-fluid" >
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">

                    <div className="d-flex align-items-center mb-3">
                      <Avatar />
                      <h6 className="ms-2 mb-0"><strong>{t("user.mail")}:</strong></h6>
                      <p className="ms-2 mb-0">{message.email}</p>
                    </div>

                    <hr />

                    <div className="d-flex align-items-center mb-3">
                      <EmailIcon />
                      <h6 className="ms-2 mb-0"><strong>{t("subject")}:</strong></h6>
                      <p className="ms-2 mb-0">{message.subject}</p>
                    </div>



                    <div className="d-flex align-items-center mb-3">
                      <BodyIcon />
                      <h6 className="ms-2 mb-0"><strong>{t("body")}:</strong></h6>
                      <p className="ms-2 mb-0">{message.body}</p>
                    </div>

                    <div className="d-flex align-items-center mb-3">
                      <DateIcon />
                      <h6 className="ms-2 mb-0"><strong>Date:</strong></h6>
                      <p className="ms-2 mb-0">{moment(message.date).format('MMMM D, YYYY')} ({moment(message.date).fromNow()})</p>
                    </div>
                  </div>
                </div>


                <hr />


                <div className="card">
                  <div className="card-body">
                    <Typography variant="h6" gutterBottom>{t("replyEmail")}</Typography>
                    <TextField
                      label={t("user.mail")}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      defaultValue={message.email}
                      disabled={true}
                    />
                    <TextField
                      label={t("subject")}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      value={replySubject}
                      onChange={(e) => setReplySubject(e.target.value)}
                    />
                    <TextField
                      label={t("body")}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      multiline
                      rows={4}
                      value={replyBody}
                      onChange={(e) => setReplyBody(e.target.value)}
                    />
                    <Button onClick={replyMessage} variant="contained" color="primary" sx={{ mt: 2 }}>
                      {t("sendReply")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      )}
    </LoaderComponent>
  );
};

export default AdminDetailContact;